import React from "react";

interface CopyIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const NewCopyIcon: React.FC<CopyIconProps> = ({
  size = 18,
  color = '#292D32',
}) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.33341 7.52508V9.97508C9.33341 12.0167 8.51675 12.8334 6.47508 12.8334H4.02508C1.98341 12.8334 1.16675 12.0167 1.16675 9.97508V7.52508C1.16675 5.48341 1.98341 4.66675 4.02508 4.66675H6.47508C8.51675 4.66675 9.33341 5.48341 9.33341 7.52508Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12.8334 4.02508V6.47508C12.8334 8.51675 12.0167 9.33341 9.97508 9.33341H9.33341V7.52508C9.33341 5.48341 8.51675 4.66675 6.47508 4.66675H4.66675V4.02508C4.66675 1.98341 5.48341 1.16675 7.52508 1.16675H9.97508C12.0167 1.16675 12.8334 1.98341 12.8334 4.02508Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default NewCopyIcon;
